import styled from 'styled-components';

import { mediaQuery } from '../../../../../styles/global';

export const Wrapper = styled.div`
  display: flex;
  justify-content: space-around;
  padding: 100px 20px 150px;
  flex-wrap: wrap;
  gap: 2rem;
  ${mediaQuery.maxWidth.phone} {
    padding: 60px 20px;
  }
`;

export const BackgroundPanel = styled.div`
  border-top-right-radius: 32px;
  border-top-left-radius: 32px;
  padding-top: 5rem;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0) 20%);
  position: absolute;
  width: 100%;
  left: 0;
  top: -70px;
  height: 2000px;

  ${mediaQuery.maxWidth.tablet} {
    border-radius: 0;
    padding-top: 3.5rem;
  }
`;

export const Statement = styled.div`
  max-width: 400px;
  display: flex;
  flex-direction: column;
`;

export const Caption = styled.h3`
  font-size: 2rem;
  font-family: ${({ theme }) => theme.fontFamily.bold};
  color: ${({ theme }) => theme.colors.white};
  margin: 1rem 0 0;
  ${mediaQuery.maxWidth.phone} {
    font-size: 1.5rem;
  }
`;

export const Description = styled.div`
  line-height: 170%;
  font-family: ${({ theme }) => theme.fontFamily.regular};
`;

export const Accent = styled.p`
  line-height: 150%;
  font-size: 1.5rem;
  font-family: ${({ theme }) => theme.fontFamily.regular};
`;
